<template>
	<div class="authsucc">
		<div class="header">
			<img src="../../../assets/images/account/auth_succ.png" />
			<div><span>恭喜您! 实名认证成功</span></div>
		</div>

		<div class="footer">
			<van-button @click="back()" type="info"> {{ idcardBefore === '/cepverification' ? '开始测评' : '返回' }} ({{ count }}) </van-button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { countdown } from '../libs/index'

const constraints = {
	video: {
		width: 500,
		height: 500,
	},
}
const counter = countdown()
export default {
	name: 'authsucc',
	data() {
		return {
			count: 5,
		}
	},
	computed: {
		idcardBefore() {
			return this.$store.state.idcardBefore
		},
	},
	mounted() {
		const counterHandler = counter.start(this.count)
		counterHandler.onTick = (second) => {
			this.count = second
		}
		counterHandler.onEnd = () => {
			this.back()
		}
		this.counterHandler = counterHandler
		localStorage.setItem('firstfaceauth', '1')
	},
	beforeDestroy() {
		this.counterHandler.destory()
	},
	beforeRouteLeave(to, from, next) {
		if (to.path !== '/scan') {
			next(true)
			return
		}
		next(false)
	},
	methods: {
		back() {
			let homepage = this.$store.state.homepage || []
			if (this.idcardBefore) {
				if (this.idcardBefore === '/') {
					/**
					 * 判断配置项是否配置首页如配置首页进入首页否则进入大平台首页
					 */
					console.log(homepage, 'homepage===')
					if (homepage.length && homepage[0].value) {
						this.$router.push(homepage[0].value)
					} else {
						this.$router.push({ name: 'home' })
					}
				} else if (this.idcardBefore === '/cepverification') {
					this.$router.push({
						path: '/humanResting/respondPage',
						query: {
							id: this.$route.query.id,
							refId: this.$route.query.refId,
							refType: this.$route.query.refType,
							respondlink: this.$route.query.respondlink,
						},
					})
				} else {
					/**
					 * 如果存储的路由和当前路由一样返回到首页
					 */
					let path = this.idcardBefore.split('?')[0]
					if (path == this.$route.path) {
						if (homepage.length && homepage[0].value) {
							this.$router.push(homepage[0].value)
						} else {
							this.$router.push({ name: 'home' })
						}
					} else {
						if (path === '/modifyPhone') {
                            sessionStorage.setItem('modifyPhone', 1)
                            this.$router.back()
                            return
						}
						this.$router.replace(this.idcardBefore)
					}
				}
			} else {
				if (this.$route.query.courseId) {
					this.$router.push({
						path: '/scourse',
						query: {
							courseId: this.$route.query.courseId,
							trainId: this.$route.query.trainId || '',
							studyProcess: this.$route.query.studyProcess,
						},
					})
				} else if (this.$route.query.trainItemExamId) {
					this.$router.push({
						path: '/examlistDetails',
						query: {
							backType: this.$route.query.backType,
							trainItemExamId: this.$route.query.trainItemExamId,
							type: this.$route.query.type,
							contentId: this.$route.query.contentId,
							trainId: this.$route.query.trainId,
						},
					})
				} else {
					/**
					 * 如果没有存储路由则返回首页
					 */
					// console.log(homepage,'homepage===')
					if (homepage.length && homepage[0].value) {
						this.$router.push(homepage[0].value)
					} else {
						this.$router.push({ name: 'home' })
					}
					// this.$router.go(-4)
				}
			}
		},
	},
}
</script>
<style scoped>
.authsucc {
	display: flex;
	font-size: 1rem;
	flex-direction: column;
	align-items: center;
	height: 100vh;
}

.authsucc .header {
	margin-top: 100px;
	text-align: center;
}

.authsucc .footer {
	margin-top: 100px;
}
.van-button {
	width: 250px;
	font-size: 18px;
	border-radius: 50px;
}
</style>
